module.exports = __webpack_public_path__ + "static/media/IMG_3380.f24bebc9.JPG";